import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, UrlTree } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { NavigationService } from "../service/navigation.service";

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class EnvironmentGuard implements CanActivate {
  constructor(protected navService: NavigationService) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    if (!environment[route.data["envVariable"]]) {
      this.navService.data404Redirect("403");
    }
    return environment[route.data["envVariable"]];
  }
}
